import { Injectable } from '@angular/core';
import { Project } from './project';
import { ArcService } from './arc.service';
import { DbRecord } from './db-record';
import { CriterionService } from './criterion.service';
import { Criterion } from './criterion';
import { RuntimeService } from './runtime.service';
import { RatingService } from './rating.service';

@Injectable()
export class DbRecordService {
  ratingService: RatingService;
  dbRecordsMap = new Map<string, Map<string, DbRecord>>();
  listsMap = new Map<string, DbRecord[]>();
  cs: CriterionService;
  private _lastLinkCode = 1;
  private _sourcesCache = new Map<string, string[]>()

  constructor(
    private arcs: ArcService,
    private rs: RuntimeService
  ) { }

  notes(dbRecord: DbRecord) {
    return dbRecord.project.dbRecordNotes(dbRecord);
  }

  hasRatingCode(dbRecord: DbRecord, code: string) {
    const m = this.rs.currentProject.ratingSummary(dbRecord, 'abstract');
    if (!m) {
      return false;
    };
    let val = false;
    m.forEach(x => {
      (x[1]).forEach(y => {
        if (y === code) {
          val = true;
        }
      });
    });
    return val;
  }

  hasOwnerNote(dbRecord: DbRecord) {
    return dbRecord.project.dbRecordHasOwnerNote(dbRecord);
  }

  setLastLinkCode(i) {
    this._lastLinkCode = i;
  }

  setLinkCodes(project: Project) {
    let newCodeLs = [];
    this.dbRecordsMap.get(project.id).forEach(x => {
      if (!x.linkCode) {
        x.linkCode = `lnk${this._lastLinkCode++}`;
        newCodeLs.push([x.recordId, x.linkCode]);
      }
    });
    if (newCodeLs.length) {
      let obs = this.arcs.run({
        fun: 'saveLinkCodes',
        project: project.id,
        codes: newCodeLs
      });
      obs.subscribe((resp) => console.log(123, resp));
    }
  }

  getProjectSources(project: Project) {
    const m = new Map<string, [string, string[]]>();
    this.dbRecordsMap.get(project.id).forEach(dbr => {
      const k = dbr.source && dbr.source.toLowerCase() || '???';
      const tpl = m.get(k);
      let ls;
      if (tpl) {
        ls = tpl[1];
      } else {
        ls = [];
        m.set(k, [dbr.source || '???', ls]);
      }
      ls.push(dbr);
    });
    const sss = []
    m.forEach(tpl => {
      sss.push(tpl);
    })
    sss.sort((x, y) => x[0].toLowerCase() < y[0].toLowerCase() ? -1 : 1);
    return sss;
  };

  getProjectRecords(project: Project, ls: Object[]) {
    this.dbRecordsMap.clear();
    this.listsMap.clear();

    this.dbRecordsMap.set(project.id, new Map<string, DbRecord>());
    this.listsMap.set(project.id, []);
    let downloads = new Set<string>();
    ls.forEach((x) => {
      downloads.add(x['filename']);
      let obs = this.arcs.run({
        fun: 'downloadRecordsFile',
        isDownload: true,
        path: x['filename']
      });
      obs.subscribe((resp) => {
        if (x['filename'].split('/').pop() === '_supportData') {
          project.initSupportData(resp);
        } else if
        (x['filename'].split('/').pop() === '_searchScores.json') {
          resp.forEach(tpl => {
            this.cs.newExternal(project, tpl[0], tpl[1]);
          });
        }
        else {
          resp.forEach(obj => new DbRecord(this, project, obj));
        }
        downloads.delete(x['filename']);
        if (!downloads.size) {
          project.isInitialized = true;
          this.setLinkCodes(project);
        }
      });
    });
  }

  getTotalDbRecordsCount(project: Project) {
    let m = this.dbRecordsMap.get(project.id);
    if (m)
      return m.size;
    else
      return 0;
  }

  getProjectDbRecordsList(project: Project) {
    return this.listsMap.get(project.id) || [];
  }

  getCriterion(id: string): Criterion {
    return this.rs.currentProject.criterionsMap.get(id);
  }
}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/db-record.service.ts